import { render, staticRenderFns } from "./CampaignListWidget.vue?vue&type=template&id=4f0734b9&scoped=true&"
import script from "./CampaignListWidget.vue?vue&type=script&lang=js&"
export * from "./CampaignListWidget.vue?vue&type=script&lang=js&"
import style0 from "./CampaignListWidget.vue?vue&type=style&index=0&id=4f0734b9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0734b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDataTable,VRow})
